export const binarySearchInsertIndex = <T extends {}>(
  sortedArray: T[],
  element: T,
  compareFunction: (newElement: T, arrayElement: T) => number,
  direction: 'asc' | 'desc',
) => {
  let start = 0;
  let end = sortedArray.length - 1;

  let middle = Math.floor((start + end) / 2);
  while (start <= end) {
    middle = Math.floor((start + end) / 2);
    const compareResult =
      direction === 'asc'
        ? compareFunction(element, sortedArray[middle])
        : compareFunction(sortedArray[middle], element);

    if (compareResult > 0) {
      // continue searching to the right for ASC
      start = middle + 1;
    } else if (compareResult < 0) {
      // search searching to the left for ASC
      end = middle - 1;
    } else {
      return middle;
    }
  }
  return end + 1;
};

// Note: this is not a fully-functional merge sort, but a somewhat modifed component of it
// to merge 2 already descendently sorted arrays of objeccts
export const mergeDescSortedArrays = <T extends {}>(
  firstSortedArray: T[],
  secondSortedArray: T[],
  isBigger: (a: T, b: T) => boolean,
) => {
  const merged: T[] = [];
  // Initial index of the first array
  let i = 0;

  // Initial index of the second array
  let j = 0;

  while (i < firstSortedArray.length && j < secondSortedArray.length) {
    if (isBigger(firstSortedArray[i], secondSortedArray[j])) {
      merged.push(firstSortedArray[i]);
      i += 1;
    } else {
      merged.push(secondSortedArray[j]);
      j += 1;
    }
  }

  const fullyMerged = [
    ...merged,
    ...firstSortedArray.slice(i),
    ...secondSortedArray.slice(j),
  ];

  return fullyMerged;
};
